import React, { useState } from 'react';
import { Scanner } from '@yudiel/react-qr-scanner';
import { X, Camera, AlertCircle } from 'lucide-react';

/**
 * TSBScanModal — Camera-based QR scanner.
 * On successful scan, parses payloads of forms:
 *   - "tsb:<user_id>"  → returns "<user_id>"  (TSB native wallet)
 *   - raw UUID         → returns as-is
 *   - upi://... links  → ignored (TSB only)
 * Calls onScan(value) and closes.
 */
const TSBScanModal = ({ open, onClose, onScan }) => {
  const [error, setError] = useState('');

  if (!open) return null;

  const handleResult = (results) => {
    try {
      if (!results || !results.length) return;
      const raw = String(results[0].rawValue || '').trim();
      if (!raw) return;
      // Accept "tsb:<id>" or raw UUID-like 36-char id
      let val = raw;
      if (raw.toLowerCase().startsWith('tsb:')) {
        val = raw.slice(4);
      }
      // Heuristic: 30+ chars => looks like our UUID
      if (val.length < 8) {
        setError('Unrecognized QR — not a TSB wallet address');
        return;
      }
      onScan(val);
      onClose();
    } catch (e) {
      setError(String(e.message || e));
    }
  };

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" data-testid="tsb-scanner-modal">
      <div className="bg-slate-900 border border-amber-500/40 rounded-2xl p-5 max-w-md w-full relative">
        <button onClick={onClose} className="absolute top-3 right-3 text-slate-400 hover:text-white" data-testid="tsb-scanner-close">
          <X className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-2 mb-3">
          <Camera className="w-5 h-5 text-amber-400" />
          <h3 className="text-lg font-bold">Scan TSB Wallet QR</h3>
        </div>
        <p className="text-xs text-slate-400 mb-3">
          Camera को point करें recipient के TSB wallet QR पर। Auto-detect होते ही P2P form भर जाएगा।
        </p>

        <div className="rounded-xl overflow-hidden bg-black" style={{ aspectRatio: '1 / 1' }}>
          <Scanner
            onScan={handleResult}
            onError={(err) => setError(String((err && err.message) || err || 'Camera error'))}
            constraints={{ facingMode: 'environment' }}
            styles={{ container: { width: '100%', height: '100%' } }}
            components={{ finder: true, audio: false }}
          />
        </div>

        {error && (
          <div className="mt-3 text-xs text-red-300 bg-red-500/10 border border-red-500/30 rounded-lg p-2 flex items-start gap-2" data-testid="tsb-scanner-error">
            <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
            <div>{error}</div>
          </div>
        )}
        <div className="mt-3 text-[10px] text-slate-500 text-center">
          Camera permission browser से माँगा जाएगा। यह data device से बाहर नहीं जाता।
        </div>
      </div>
    </div>
  );
};

export default TSBScanModal;
